import React from "react"
import "./Project.css"
import Project1 from "./img/portfolio-1.png"
import Project2 from "./img/portfolio-2.png"
import Project3 from "./img/portfolio-3.png"
import Project4 from "./img/portfolio-4.png"
import Project5 from "./img/portfolio-5.png"
import Project6 from "./img/portfolio-6.png"
function Project() {
  return (
    <div className="project component__space" id="Portfolio">
      <div className="heading">
        <h1 className="heading">Mes derniers Projets</h1>
        <p className="heading p__color">
          juste un aperçu de ce que pourait ressembler le votre
        </p>
        <p className="heading p__color">Ensembles c'est mieux.</p>
      </div>
      <div className="container">
        <div className="row">
          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={Project1} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                <h5 className="project__text">Development</h5>
                <h4 className="project__text">
                  Getting tickets to the big show
                </h4>
                <a href="#" className="project__btn">
                  View Details
                </a>
              </div>
            </div>
          </div>

          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={Project2} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                <h5 className="project__text">Community Manaement</h5>
                <h4 className="project__text">
                  Entretient de l'Imarge de Marque.
                </h4>
                <a href="#" className="project__btn">
                  Details
                </a>
              </div>
            </div>
          </div>

          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={Project3} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                <h5 className="project__text">Marketing business Expert</h5>
                <h4 className="project__text">Promotion De Marque</h4>
                <a href="#" className="project__btn">
                  Details
                </a>
              </div>
            </div>
          </div>

          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={Project4} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                <h5 className="project__text">Marketing digital</h5>
                <h4 className="project__text">
                  Promotion D'un Tube De FAFA du Coeur
                  (Facebook-Youtube-Instagram-TikTok ...)
                </h4>
                <a href="#" className="project__btn">
                  Details
                </a>
              </div>
            </div>
          </div>

          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={Project5} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                <h5 className="project__text">Gadget de télécommunitions...</h5>
                <h4 className="project__text">
                  Box Android , Camera De Surveillances, Camera Espions
                  ,Abpnnement IPTV
                </h4>
                <a href="#" className="project__btn">
                  View Details
                </a>
              </div>
            </div>
          </div>

          <div className="col__3">
            <div className="project__box pointer relative">
              <div className="project__box__img pointer relative">
                <div className="project__img__box">
                  <img src={Project6} alt="" className="project__img" />
                </div>
                <div className="mask__effect"></div>
              </div>
              <div className="project__meta absolute">
                <h5 className="project__text">Materiels de Bureautique</h5>
                <h4 className="project__text">
                  Equipement du Collège Bilingue Saint John de Nkongg
                </h4>
                <a href="#" className="project__btn">
                  Details
                </a>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="view__more__btn d__flex align__items__center justify__content__center pxy__30">
              <button className="view__more pointer btn">View more</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Project
